import { ChatBlkQueries } from './query';

export interface ChatBlkCustomProps extends ChatBlkAppContext {
    name?: string;
    domElement?: HTMLElement;
    appContext?: ChatBlkAppContext;
    isOpen?: boolean;
    // Can be an element or a selector string
    hostHeader?: HTMLElement | string;
}

export interface DisplayMessage {
    primary: string;
    secondary: string;
    disclaimer: string;
    hideDisclaimer: boolean;
    displayAppName: string;
}

export enum CopilotChatInitialWidth {
    SMALL = 420,
    MEDIUM = 620,
    LARGE = 820,
}

export enum ChatBlkInitialWidth {
    XS = 360,
    LMS = 424,
    XL = 606,
}

export interface CopilotMFEProps {
    hasHeader?: boolean;
    hasCloseButton?: boolean;
    initialWidth?: CopilotChatInitialWidth;
}

export interface ChatBlkMFEProps {
    isProd?: boolean;
    isLoggedIn?: boolean;
    rootElement?: Element;
    username?: string;
    email?: string;
    userInitials?: string;
}

export interface CopilotAIContentFilters {
    product: Array<string>;
    'product-area': Array<string>;
    'service-offering': Array<string>;
    topic: Array<string>;
    [key: string]: Array<string>;
}

export interface CopilotAIProps<T = unknown>
    extends Omit<PromptRequest, 'contentFilters' | 'customProps'> {
    // Optionals properties passed by app teams
    customProps?: T;
    contentFilters?: Partial<CopilotAIContentFilters>;
    sessionId?: string;
}

export interface CopilotAppContext<T = unknown> extends CopilotMFEProps {
    displayMessage?: Partial<DisplayMessage>;
    aiProps?: CopilotAIProps<T>;
    isBeta?: boolean;
    theme?: 'light' | 'dark';
    isExternal?: boolean;
}

export interface ChatBlkAppContext<T = unknown>
    extends CopilotMFEProps,
        ChatBlkMFEProps {
    displayMessage?: Partial<DisplayMessage>;
    aiProps?: CopilotAIProps<T>;
    isBeta?: boolean;
    isExternal?: boolean;
}

/**
 *
 * @export
 * @interface PromptRequest
 */
export interface PromptRequest {
    /**
     *
     * @type {string}
     * @memberof PromptRequest
     */
    appName?: string;
    /**
     *
     * @type {string}
     * @memberof PromptRequest
     */
    appVersion?: string;
    /**
     *
     * @type {string}
     * @memberof PromptRequest
     */
    sessionId?: string;
    /**
     *
     * @type {string}
     * @memberof PromptRequest
     */
    aiEngine?: PromptRequestAiEngineEnum;
    /**
     *
     * @type {PromptRequestAgentInput}
     * @memberof PromptRequest
     */
    agent_input?: PromptRequestAgentInput;
    /**
     *
     * @type {{ [key: string]: Set<string>; }}
     * @memberof PromptRequest
     */
    contentFilters?: { [key: string]: Set<string> };
    /**
     *
     * @type {{ [key: string]: Set<string>; }}
     * @memberof PromptRequest
     */
    customProps?: { [key: string]: Set<string> };
    /**
     *
     * @type {boolean}
     * @memberof PromptRequest
     */
    useSurfaceSDK?: boolean;
    /**
     *
     * @type {string}
     * @memberof PromptRequest
     */
    requestId?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PromptRequestAiEngineEnum {
    AladdinV1 = 'ALADDIN_V1',
    Efront = 'EFRONT',
    ChatBlkV1 = 'CHAT_BLK_V1',
}

/**
 *
 * @export
 * @interface PromptRequestAgentInput
 */
export interface PromptRequestAgentInput {
    /**
     *
     * @type {string}
     * @memberof PromptRequestAgentInput
     */
    query?: string;
    /**
     *
     * @type {ChatBlkQueries}
     * @memberof PromptRequestAgentInput
     */
    past_messages?: ChatBlkQueries;
}
